import React from "react";
import DateRangePicker from "../../../commonComponents/DateRangePicker";
import DateSelector from "../../../commonComponents/DateSelector";
import ChartSelection from "../../../commonComponents/ChartSelection";
import BarLineChart from "../../../commonComponents/BarLineChart";
import KeyMetricsSelector from "../../../commonComponents/KeyMetricSelector";
import {
  ChartCard,
  ChartControls,
  ChartContainer,
  EmptyState,
  EmptyStateText,
} from "./styles";
import { DeliveryChartSectionProps, ChartDataItem } from "./types";
import { METRIC_OPTIONS, EMPTY_STATE_MESSAGES } from "./constants";

const DeliveryChartSection: React.FC<DeliveryChartSectionProps> = ({
  deliveryData,
  selectedDateRange,
  chartType,
  metricOption,
  isLoading = false,
  onDateRangeChange,
  onDateSelect,
  onMetricChange,
  onChartTypeChange,
}) => {
  const prepareChartData = (): ChartDataItem[] => {
    if (!deliveryData?.byDistance) return [];

    return Object.entries(deliveryData.byDistance).map(([key, value]) => ({
      category: key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()),
      orders: value.orders,
      revenue: value.revenue,
      cost: value.cost,
      profit: value.profit,
      avgDistance: value.avgDistance,
    }));
  };

  const chartData = prepareChartData();

  return (
    <ChartCard>
      <ChartControls>
        <DateRangePicker
          selectedDateRange={selectedDateRange}
          onDateRangeChange={onDateRangeChange}
        />
        <DateSelector onDateSelect={onDateSelect} />
        <KeyMetricsSelector
          options={METRIC_OPTIONS}
          onSelectionChange={onMetricChange}
        />
        <ChartSelection onChange={onChartTypeChange} />
      </ChartControls>

      <ChartContainer>
        {chartData.length > 0 ? (
          <BarLineChart
            data={chartData}
            chartType={chartType}
            xKey="category"
            yKey={metricOption}
            valueKey={metricOption}
            isLoading={isLoading}
          />
        ) : (
          <EmptyState>
            <EmptyStateText>{EMPTY_STATE_MESSAGES.noDeliveryData}</EmptyStateText>
          </EmptyState>
        )}
      </ChartContainer>
    </ChartCard>
  );
};

export default DeliveryChartSection;
